import React, { useState, useContext, useEffect } from "react";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { ReactComponent as Mail } from "../../svgs/mail.svg";
import { ReactComponent as Eye } from "../../svgs//eye.svg";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { session } from "../../../redux/slices/auth-slice";
import { TopLoaderContext } from "../../../context/TopLoader";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
// import { LuLoader2 } from "react-icons/lu";
// import { useLogin } from "../../../hooks/useLogin";

const LoginForm = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { token } = useParams();
  const { loadingRef } = useContext(TopLoaderContext);
  const navigate = useNavigate();

  // console.log("Token :", token);

  const { user, signInLoading, isAuth , isSession } = useSelector(
    (state) => state.authReducer
  );

  const userEmail = user ? user.email : "";

  useEffect(() => {
    if (!signInLoading) loadingRef.current.complete();
  }, [signInLoading, loadingRef]);

  useEffect(() => {
    if (isSession) {
      navigate("/");
    }
  }, [isSession]);


  const onEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const onPasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    loadingRef.current.continuousStart();
    dispatch(session({ email, password, token }));
  };

  // const onSubmitHandler = async (event) => {
  //   event.preventDefault();
  // const { success } = await login(email, password);
  //   if (success) {
  //     setEmail("");
  //     setPassword("");
  //   }
  // };

  return (
    <form
      noValidate
      className="w-full flex flex-col gap-y-6 mt-16"
      onSubmit={onSubmitHandler}
    >
      <Input
        label="Email"
        type="email"
        className="w-full"
        Icon={Mail}
        onChange={onEmailChange}
        value={email}
        autoFocus={true}
        required={true}
      />
      <Input
        label="Password"
        type="password"
        className="w-full"
        Icon={Eye}
        onChange={onPasswordChange}
        value={password}
        required={true}
      />
      {/* <p className="text-gray-400 text-sm self-end">
        Forgot your Password?
        <span className="text-blue-800 ml-2">Reset</span>
      </p> */}

      <Button
        type="submit"
        color="blue"
        varient="rounded"
        className="w-fit py-2 px-16 mx-auto text-2xl tracking-widest text-white mt-12"
      >
        {/* {loading ? <LuLoader2 className=" animate-spin" /> : "Login"} */}{" "}
        Login
      </Button>
    </form>
  );
};

export default LoginForm;
